/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CustomerReadQuery($customerType: CUSTOMER_TYPE, $take: PositiveInt!, $skip: Int!) {
  CustomerRead(customerType: $customerType, take: $take, skip: $skip, returnDeliveriesOfTrunk: false) {
    id,
    displayName,
    message,
    status
  }
}
`
